export const WizardIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 27 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.543 22.173C21.651 22.2836 21.8283 22.2858 21.939 22.1778C22.0496 22.0698 22.0518 21.8925 21.9438 21.7819L21.7434 21.9774L21.543 22.173ZM21.7434 21.9774L21.9438 21.7819L11.1049 10.6739L10.9045 10.8695L10.7041 11.065L21.543 22.173L21.7434 21.9774Z"
				fill="#262A2D"
			/>
			<path
				d="M5.77229 6.50249C5.57549 6.06919 6.14829 5.49639 6.5816 5.69319C7.52214 6.12036 8.69353 6.53929 9.67029 6.53929C10.647 6.53929 11.8184 6.12036 12.759 5.69319C13.1923 5.49639 13.7651 6.06919 13.5683 6.50249C13.1411 7.44304 12.7222 8.61443 12.7222 9.59119C12.7222 10.5679 13.1411 11.7393 13.5683 12.6799C13.7651 13.1132 13.1923 13.686 12.759 13.4892C11.8184 13.062 10.647 12.6431 9.67029 12.6431C8.69353 12.6431 7.52214 13.062 6.5816 13.4892C6.14829 13.686 5.57549 13.1132 5.77229 12.6799C6.19946 11.7393 6.61839 10.5679 6.61839 9.59119C6.61839 8.61443 6.19946 7.44304 5.77229 6.50249Z"
				fill="url(#paint0_linear_1792_2)"
			/>
			<path
				d="M6.00971 5.97202C6.21294 5.76879 6.5639 5.60521 6.9081 5.76141C7.7597 6.14819 8.78086 6.50772 9.60739 6.50787C10.4339 6.50787 11.4557 6.1489 12.3074 5.7621C12.6515 5.60581 13.0018 5.76887 13.2051 5.97202C13.4083 6.17529 13.572 6.52614 13.4157 6.8704C13.0289 7.7221 12.6692 8.74321 12.6692 9.5697C12.6692 10.3962 13.0289 11.4173 13.4157 12.269C13.572 12.6133 13.4083 12.9641 13.2051 13.1674C13.0018 13.3705 12.6515 13.5336 12.3074 13.3773C11.4557 12.9905 10.4339 12.6315 9.60739 12.6315C8.78086 12.6317 7.7597 12.9912 6.9081 13.378C6.5639 13.5342 6.21294 13.3706 6.00971 13.1674C5.80662 12.9641 5.64372 12.6137 5.79979 12.2697C6.18665 11.4179 6.54557 10.3963 6.54557 9.5697C6.54557 8.74308 6.18665 7.7215 5.79979 6.86971C5.64372 6.52569 5.80662 6.17527 6.00971 5.97202Z"
				stroke="#262A2D"
				strokeWidth="0.56"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1792_2"
					x1="15.1826"
					y1="8.97595"
					x2="5.18262"
					y2="8.97595"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.0923544" stopColor="#DADADA" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
			</defs>
		</svg>
	);
};
